export const UPDATE_OPEN_PROCESS_STATEMENT_SUCCESS = 'UPDATE_OPEN_PROCESS_STATEMENT_SUCCESS';

export const updateOpenProcessStatementSuccess = processStatement => ({
    type: UPDATE_OPEN_PROCESS_STATEMENT_SUCCESS,
    payload: { processStatement },
});
